import withStore from '../../utils/with-store'
import ServiceWorkerStore from './stores/service-worker-store'

const ServiceWorkerHandler = () => {
  return null
}

export default withStore([ServiceWorkerStore])(ServiceWorkerHandler)
